import VideoBackgroundAssetComponent from "./video-background-asset-component";
import VideoBackgroundAssetConfig from "./video-background-asset-config";
import VideoBackgroundAssetAdvancedConfig from "./video-background-asset-advanced-config";

export default {
  VideoBackgroundAssetComponent,
  VideoBackgroundAssetConfig,
  VideoBackgroundAssetAdvancedConfig
};
